import { Link } from "react-router-dom";
import { TelegramLogo, WhatsappLogo, FacebookLogo, YoutubeLogo } from "@phosphor-icons/react";

const SOCIAL = [
  {
    label: "Telegram",
    href: "https://t.me/MorningSundayTeer",
    Icon: TelegramLogo,
    className: "bg-[#229ED9] hover:bg-[#1a86ba]",
  },
  {
    label: "WhatsApp",
    href: "https://whatsapp.com/channel/0029Vb8MzS9F1YlWpvY4M81x",
    Icon: WhatsappLogo,
    className: "bg-[#25D366] hover:bg-[#1fbf5a]",
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/share/18nZVtunj6/",
    Icon: FacebookLogo,
    className: "bg-[#1877F2] hover:bg-[#1367d5]",
  },
  {
    label: "YouTube",
    href: "https://youtube.com/@morningteerliveresult?si=EVVZwViXcUBP7RGt",
    Icon: YoutubeLogo,
    className: "bg-[#FF0000] hover:bg-[#d90000]",
  },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-neutral-950 text-neutral-400 border-t border-neutral-900" data-testid="site-footer">
      {/* Social row */}
      <div className="border-b border-neutral-900">
        <div className="max-w-7xl mx-auto px-4 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-xs uppercase tracking-widest text-neutral-500 font-bold">Follow Juwai Teer</div>
          <div className="flex items-center gap-3" data-testid="social-links">
            {SOCIAL.map(({ label, href, Icon, className }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className={`w-10 h-10 rounded-full flex items-center justify-center text-white transition-transform active:scale-90 hover:-translate-y-0.5 ${className}`}
                data-testid={`social-${label.toLowerCase()}`}
              >
                <Icon size={20} weight="fill" />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10 grid grid-cols-1 sm:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2 flex-wrap">
            <img src="/logo-192.png" alt="Juwai Teer" width={36} height={36} className="w-9 h-9 rounded-full ring-1 ring-red-500/40 object-cover" />
            <div className="font-heading font-black text-lg text-white tracking-tight">JUWAI TEER</div>
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-500/15 border border-emerald-500/40 text-emerald-300 text-[10px] font-bold uppercase tracking-widest" data-testid="since-badge">
              Since 2018
            </span>
          </div>
          <p className="mt-2 text-sm">
            One place for all Teer results — homepage, per-game history and common numbers. Trusted since 2018,
            still running strong in {new Date().getFullYear()}.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-neutral-500 font-bold">Navigate</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/" className="hover:text-white">Home</Link></li>
            <li><Link to="/all-results" className="hover:text-white">All Results</Link></li>
            <li><Link to="/about" className="hover:text-white">About</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-neutral-500 font-bold">Info</div>
          <p className="mt-3 text-xs leading-relaxed">
            All times shown in IST (Asia/Kolkata). Historical demo data is clearly labeled internally and can
            be replaced with verified official results.
          </p>
        </div>
      </div>

      {/* Disclaimer + trust block */}
      <div className="border-t border-neutral-900 bg-neutral-950" data-testid="footer-disclaimer">
        <div className="max-w-7xl mx-auto px-4 py-6 text-neutral-500 text-[11px] leading-relaxed space-y-3">
          <div className="flex items-center gap-2 text-neutral-300">
            <span className="w-5 h-5 rounded-full bg-red-600 text-white flex items-center justify-center text-[10px] font-black">18+</span>
            <span className="font-bold uppercase tracking-widest text-xs">Disclaimer &amp; Community Guidelines</span>
          </div>
          <p>
            Juwai Teer is an independent Teer result information portal that has been serving visitors
            since <strong className="text-neutral-300">2018</strong> and is still actively updated in
            {" "}<strong className="text-neutral-300">{new Date().getFullYear()}</strong>. All FR, SR, previous
            result and common number information on this website is provided strictly for
            <strong className="text-neutral-300"> informational and educational purposes only</strong>.
          </p>
          <p>
            This website does not sell, promote, encourage or facilitate any form of gambling, betting or
            wagering. We do not accept money, deposits or wagers of any kind. We do not guarantee any winnings
            and we do not claim any predictions to be official or accurate. Please verify every number with your
            local official Teer counter before acting on it.
          </p>
          <p>
            Juwai Teer is not affiliated with, endorsed by or connected to any Teer Association, Teer Counter,
            Meghalaya government body or any other official organisation. All trademarks and Teer names are the
            property of their respective owners and are used here only for factual reference.
          </p>
          <p>
            Access to this website is intended only for adults aged 18 years or above, and only where local laws
            permit viewing such information. If viewing Teer result content is restricted or prohibited in your
            region, please leave this website. By continuing to use Juwai Teer you agree that you are viewing
            the content of your own free will and take full responsibility for how you use the information.
          </p>
          <p>
            We follow standard community and platform guidelines — no gambling instructions, no &quot;how to play&quot;,
            no guaranteed prediction claims, no promotional gambling content, and no user-submitted content is
            displayed anywhere on this site.
          </p>
        </div>
      </div>

      <div className="border-t border-neutral-900">
        <div className="max-w-7xl mx-auto px-4 py-4 text-xs flex flex-col sm:flex-row items-center justify-between gap-2">
          <div>© 2018 – {new Date().getFullYear()} JUWAI TEER. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}
